export const GET_SIDEBAR_CONTENT = 'GET_SIDEBAR_CONTENT';
export const SIDEBAR_CONTENT_LOADING = 'SIDEBAR_CONTENT_LOADING';
export const GET_PAGE_CONTENT = 'GET_PAGE_CONTENT';
export const PAGE_CONTENT_LOADING = 'PAGE_CONTENT_LOADING';


// WEBPACK FOOTER //
// ./src/features/Content/types.js